import { MediaTypeEnum } from "../../enums";
import { AuditableBaseDto } from "../common";

export interface MediaDto extends AuditableBaseDto {
  id: string;
  name: string;
  type?: MediaTypeEnum;
  description: string;
  path: string;
  videoUrl: string;
  thumbnail: string;
  size: string;
  status: MediaStatusEnum;
  // client side
  localId?: number;
}

export enum MediaStatusEnum {
  NEW = "new",
  PROCESSING = "processing",
  FAILED = "failed",
  COMPLETED = "completed",
}
